import { DatePickerComponent } from "@syncfusion/ej2-react-calendars";
import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "../App.css";
import { format } from "date-fns";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import isWeekend from "date-fns/isWeekend";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import moment from "moment";
import { TimePicker } from "@mui/x-date-pickers";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import FormGroup from "@mui/material/FormGroup";
import { ArrowLeftIcon, ArrowSmLeftIcon } from "@heroicons/react/solid";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Checkbox from "@mui/material/Checkbox";
import axios from "axios";

const DatePicker = () => {
  const [value, setValue] = useState(new Date());

  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);
  const [ftime, setFTime] = useState(null);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [links, setLinks] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    AOS.init();
  }, []);

  const Shedule = async () => {
    setFTime(moment(time).format("h:mm a"));
    if (
      !date ||
      !time ||
      !firstName ||
      !lastName ||
      !email ||
      !phone ||
      !links ||
      !message
    ) {
      toast.error("Please enter complete details");
    } else {
      setFTime(moment(time).format("h:mm a"));
      console.log(ftime);
      const payload = {
        date,
        time,
        ftime,
        firstName,
        lastName,
        email,
        phone,
        links,
        message,
      };
      try {
        await axios.post(
          `https://video-editing-api.herokuapp.com/appoinment`,
          payload
        );
        toast.success("Your appoinment has been sheduled");
        // setDate("");
        // setTime("");
        setFirstName("");
        setLastName("");
        setEmail("");
        setPhone("");
        setLinks("");
        setMessage("");
      } catch (error) {
        toast.error(error);
      }
    }
  };

  return (
    <div className="bg-[#fff]" id="calender">
      <div className="max-w-[1320px] md:mx-auto mx-4 flex items-center justify-center  md:justify-between flex-wrap md:mt-5 py-20">
        <div className="flex-grow mx-auto max-w-[600px]">
          <h1 className="sm:text-[48px] text-[40px] text-center lg:text-left font-bold md:leading-[60px] leading-[50px] text-[#1b0c3e]">
            Book a free
          </h1>
          <h1 className="sm:text-[48px] text-[40px] text-center lg:text-left font-bold md:leading-[60px] leading-[50px] text-[#1b0c3e]">
            consultation call now to discuss details and take the next steps!
          </h1>
          <p className="mt-12 text-[22px] text-[#4f4f4f]  font-normal text-center lg:text-left">
            The consult call will help us assess your needs and recommend the
            best editing package for you. During the call,
            <span className="font-semibold opacity-100">
              (which will happen over Zoom)
            </span>{" "}
            we'll...
          </p>
          <div className="list-outside">
            <li className=" list-none  mt-9 text-[20px] text-[#4f4f4f]  font-normal text-center lg:text-left">
              Discuss your current situation and understand where you need more
              support to help you succeed.
            </li>
            <li className=" list-none mt-2   text-[20px] text-[#4f4f4f]  font-normal text-center lg:text-left">
              Take you through our service offerings, ways of working, and
              smooth operations.
            </li>
            <li className="list-none mt-2   text-[20px] text-[#4f4f4f] font-normal text-center lg:text-left">
              Walk you through our available packages and discuss the best one
              for your needs.
            </li>
          </div>
        </div>
        <div className="flex-grow sm:min-w-[450px] min-w-[290px]  max-w-[591px] mx-auto  px-2 sm:px-4">
          <div className="p-4   overflow-y-scroll max-h-[580px] scrollbar-hide py-10 mt-8 bg-white  shadow-xl rounded-md xl:mt-0">
            {!time || !date ? (
              <>
                <div className="hidden md:block">
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <StaticDatePicker
                      orientation={"landscape"}
                      toolbarTitle="Select a date"
                      openTo="day"
                      value={value}
                      // shouldDisableDate={isWeekend}
                      minDate={new Date()}
                      // maxDate={new Date()}
                      onChange={(newValue) => {
                        setValue(newValue);
                        setTimeout(() => {
                          setDate(newValue);
                        }, 3000);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                  <div className="mt-2 text-center">
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <TimePicker
                        label="Select your time"
                        value={time}
                        onChange={(newValue) => {
                          // console.log("new value", time);
                          setTimeout(() => {
                            setTime(newValue);
                          }, 3000);
                        }}
                        renderInput={(params) => <TextField {...params} />}
                        onError={(e) => e.message}
                      />
                    </LocalizationProvider>
                  </div>
                </div>
                <div className="md:hidden">
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <StaticDatePicker
                      orientation={"portrait"}
                      toolbarTitle="Select a date"
                      openTo="day"
                      value={value}
                      // shouldDisableDate={isWeekend}
                      minDate={new Date()}
                      // maxDate={new Date()}
                      onChange={(newValue) => {
                        setValue(newValue);
                        setTimeout(() => {
                          setDate(newValue);
                        }, 3000);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                  <div className="mt-2 text-center">
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <TimePicker
                        label="Select your time"
                        value={time}
                        onChange={(newValue) => {
                          setTimeout(() => {
                            setTime(newValue);
                          }, 3000);
                        }}
                        renderInput={(params) => <TextField {...params} />}
                        onError={(e) => e.message}
                      />
                    </LocalizationProvider>
                  </div>
                </div>
              </>
            ) : (
              <div></div>
            )}
            {time && (
              <div
                data-aos="fade-left"
                data-aos-delay="200"
                data-aos-duration="1000"
              >
                {/* <ArrowSmLeftIcon /> */}
                <ArrowLeftIcon
                  onClick={() => {
                    setDate(null);
                    setTime(null);
                  }}
                  className="w-6 h-5 mb-3 -mt-4 cursor-pointer"
                />
                <p className="mb-6 text-lg font-semibold">
                  Shedule for {moment(date).format("MMMM Do YYYY")} at{" "}
                  {moment(time).format("h:mm a")} for 30 min.
                </p>
                <div>
                  <div className="flex flex-wrap justify-between mt-5 lg:justify-start">
                    <input
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      type="text"
                      placeholder="First Name"
                      className="p-[14px]  border  lg:w-[250px] my-2 w-[98%]  border-gray-400 rounded-[4px] outline-none"
                    />
                    <input
                      type="text"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                      placeholder="Last Name"
                      className="p-[14px] lg:ml-2 border lg:w-[255px] my-2 w-[98%] border-gray-400 rounded-[4px] outline-none"
                    />
                  </div>
                  <div className="">
                    <input
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      type="email"
                      placeholder="Enter your email address"
                      className="p-[14px] lg:mt-4 my-2 border  lg:w-[98%] w-[98%] border-gray-400 rounded-[4px] outline-none"
                    />
                  </div>
                  <div>
                    <PhoneInput
                      international
                      country={"us"}
                      countryCallingCodeEditable={false}
                      defaultCountry="US"
                      countryCodeEditable={false}
                      value={phone}
                      onChange={setPhone}
                      defaultMask={false}
                      containerStyle={{
                        maxHeight: "48px",
                        display: "flex",
                        backgroundColor: "transparent",
                        alignItems: "center",
                        padding: "6px 12px",
                        width: "98%",
                      }}
                      inputStyle={{
                        fontSize: "16px",
                        backgroundColor: "transparent",
                        border: "none",
                      }}
                      className="p-[14px] lg:mt-4 my-2 border lg:w-[94%] w-[98%] border-gray-400 rounded-[4px] outline-none"
                    />
                  </div>
                  <textarea
                    value={links}
                    onChange={(e) => setLinks(e.target.value)}
                    type="Message"
                    placeholder="Share at least 3 links to videos you've made. "
                    className="block resize-none scrollbar-hide border outline-none flex-1  w-[98%] p-3 rounded-md border-gray-400 my-6"
                  />
                  <p className="font-semibold">
                    Are you editing videos for yourself or on someone else's
                    behalf (i.e. a client)? *
                  </p>
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      defaultValue="female"
                      name="radio-buttons-group"
                    >
                      <FormControlLabel
                        value="female"
                        control={<Radio />}
                        label="For myself"
                      />
                      <FormControlLabel
                        value="male"
                        control={<Radio />}
                        label="For a client"
                      />
                    </RadioGroup>
                  </FormControl>

                  <textarea
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    type="Message"
                    placeholder="Anything else we should know about you ahead of our meeting?"
                    className="block resize-none scrollbar-hide border outline-none flex-1  w-[98%] p-3 rounded-md border-gray-400 my-6"
                  />
                  <p className="font-semibold">
                    Would you like to subscribe to our email list, where you can
                    receive special deals and useful insights on video creation?
                    Unsubscribe anytime! *
                  </p>
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      defaultValue="Yes"
                      name="radio-buttons-group"
                    >
                      <FormControlLabel
                        value="Yes"
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="No"
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                  <p className="font-semibold">
                    Where did you hear about us? (You can choose more than one).
                    *
                  </p>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Facebook/Instagram Ad"
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Word of Mouth Referral"
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label="YouTube Ad"
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label="YouTube Ad"
                    />
                  </FormGroup>
                  <button
                    onClick={Shedule}
                    className="p-2 px-4 rounded-[50px] bg-[#2d76fd] outline-none border-none cursor-pointer text-white font-semibold text-lg mt-6"
                  >
                    Shedule Event
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default DatePicker;
